import React from "react";
import { Menu, Skeleton } from "antd";
import styles from './DatasetMenu.module.scss'
import {DatasetTag} from "./DatasetTag";
import {useAppSelector} from "../../hooks";
import {selectDatasets} from "./glossarySlice";

export type DatasetMenuProps = {
    selectedDataset: number | undefined,
    setSelectedDataset: (datasetId: number | undefined) => void
}

export const DatasetMenu = ({selectedDataset, setSelectedDataset}: DatasetMenuProps) => {
    const datasets = useAppSelector(selectDatasets)

    return <div
        className={styles['dataset-menu']}
    >
        { datasets === undefined ? <Skeleton active /> : <Menu
            selectedKeys={[`${selectedDataset ?? 'all-datasets'}`]}
            onSelect={(e) => setSelectedDataset(e.key === 'all-datasets' ? undefined : parseInt(e.key))}
            mode="inline"
            items={[
                {
                    label: <DatasetTag className={styles['first-item']} title={'All Datasets'}  selected={selectedDataset === undefined}/>,
                    key:  'all-datasets'
                },
                ...(datasets ?? []).map((dataset, index) => {
                    return {
                        label: <DatasetTag colourIndex={index} title={dataset.title} selected={selectedDataset === dataset.id}/>,
                        key: dataset.id
                    }
                }),
            ]}
        />}
    </div>
}